import { assertFlagStatusName } from './assertFlagStatusName';

export function ensureFlagStatusName(name: unknown) {
  assertFlagStatusName(name);
  return name;
}
